<div class="pointer service_box overflow-hidden br-8 transition025 position-relative"
     [ngClass]="[layoutMode, classes]"  id="dashboard_start_{{process.key}}"
     (click)="nextStep(process)">
<!------------------------------   HEADER (image + picto)  ------------------------------>
  <div class="service_img br-8 w-100 position-relative font-14 overflow-hidden"
       [style.background-image]="'url(\''+ getBackgroundImg(process) +'\')'"
       [title]="'PROCESSES.' + process.key + '.TITLE' | translate">

    <!--   pictogramme   -->
    <div class="absolute-top-left-centered p-2 d-none d-md-flex align-items-center justify-content-center blurry aspect-ratio_1-1"
         [ngClass]="layoutMode === 'list' ? 'yellow' : 'primary'" *ngIf="process.picto_img">
      <img class="w-100" [src]="mediaURL + process.picto_img" [alt]="'PROCESSES.' + process.key + '.TITLE' | translate">
      <span class="material-icons-outlined position-absolute mat-error font-18" *ngIf="process.key == 'ACCOMMODATION' && isBookingSoonEnded" title="{{ 'NOTIF.BOOKING_END_SOON.TITLE' | translate }}">error_outline</span>
    </div>

    <!--   texte   -->
    <span class="text-white absolute-inline-centered semi-bold"  *ngIf="layoutMode !== 'list'">
      {{(process.state.name == 'NOT_STARTED' || process.state.name == 'Start process' ? 'COMMON.START' : (process.state.name !== 'DONE' && process.state.name !== 'PAYED' ? 'COMMON.TO_RESUME' : '')) | translate }}
    </span>
    <!--  list btn  -->
    <button
      *ngIf="layoutMode==='list'"
      class="d-none d-sm-flex btn border-0 text-white absolute-block-centered blurry yellow align-items-center justify-content-center transition025 aspect-ratio_1-1">
      <span class="material-icons-outlined" *ngIf="!isDownloadButton && !pdfLoading">chevron_right</span>
      <span class="material-icons" *ngIf="isDownloadButton && !pdfLoading">file_download</span>
      <span class="d-flex aspect-ratio_1-1 spinner-border spinner-border-sm v-middle" *ngIf="pdfLoading"></span>
    </button>

  </div>

  <!------------------------------   DESCRIPTIF (nom, description)  ------------------------------>
  <div [ngClass]="{'position-relative p-2': layoutMode !== 'list',
                   'flex-column flex-md-row align-items-md-center' : layoutMode === 'main-default',
                    'flex-row justify-content-between align-items-center': layoutMode != 'main-default'}"
       class="d-flex gap-8">

    <!--  NOM  -->
    <h6 class="text_4 m-0 txt-darkGray"
      [ngClass]="{'text-white absolute-block-centered': layoutMode==='list',
                    'd-flex align-items-center justify-content-center w-100': layoutMode === 'grid'}">
      <span [ngClass]="{'text-center': layoutMode == 'grid'}"
        class="flex-grow-1">{{ 'PROCESSES.' + process.key + '.TITLE' | translate }}</span>

      <!--
        @TODO : réafficher quand % & process state faits
      <small class="d-block font-12 mediumGray" *ngIf="layoutMode === 'main-in_progress'">Comprendre les engagements</small>-->

      <div class="progress_bar flex-shrink-0 pe-2"
           *ngIf="layoutMode == 'grid' && (process.state.name !== 'DONE' && process.state.name !== 'PAYED' && process.state.name !== 'NOT_STARTED' && process.state.name != 'Start process') && process.type != 'LINK'">
        <circle-progress [percent]="50" [radius]="100" [outerStrokeWidth]="30" [outerStrokeColor]="'#1C69FF'"
                         innerStrokeWidth="30" [showInnerStroke]="true" innerStrokeColor="lightgray" space="-30"
                         responsive="false" [showTitle]="false" [showUnits]="false" [showSubtitle]="false"
                         [animation]="true" [animationDuration]="300"></circle-progress>
      </div>

      <span class="material-icons-outlined text-white rounded-circle bg-success font-11 p-1 me-2"
            *ngIf="layoutMode == 'grid' && (process.state.name == 'DONE' || process.state.name == 'PAYED')">file_download_done</span>

    </h6>

    <!--  TYPE DE SERVICE  -->
    <div class="br-2 grad-bg px-2 py-1 text-white minitext_3 h-fit-content text-nowrap"
      *ngIf="layoutMode === 'main-default' || layoutMode === 'grid'"
      [ngClass]="{'absolute-inline-centered w-fit-content': layoutMode === 'grid',
                     'mobile-main-type' : layoutMode === 'main-default',
                     'orange' : process.type == 'COMPARATIVE',
                     'dark_blue' : process.type == 'LF_SERVICE',
                     'red': process.type == 'LINK'}">
      {{ ('DASHBOARD.' + process.type) | translate}}
    </div>

    <!--  IN PROGRESS BTN  -->
    <button class="btn text-primary txt-blue-sky minitext_3 bg-blueSky border-0 text-nowrap" id="dashboard_already_done_{{process.key}}"
      *ngIf="layoutMode === 'main-in_progress'" (click)="$event.stopPropagation();openModal(doneModal)">
      {{ "DASHBOARD.ALREADY" | translate }}
    </button>
  </div>

  <!--  DESCRIPTION DU PROCESS -->
  <div *ngIf="layoutMode === 'main-default'" class="minitext_1 px-2 process_description">
    {{ 'PROCESSES.' + process.key + '.DESCRIPTION' | translate }}
  </div>

</div>


<ng-template #doneModal let-modal>
  <div class="mt-4 mb-3 px-4 d-flex align-items-center">
    <h5 class="font-trueno-bold font-24" id="login-modal">{{ modalTitle | translate }}</h5>
    <button type="button" class="btn border-0 m-0 ms-auto p-0" aria-label="Close" (click)="modal.dismiss()">
      <span class="material-icons-outlined text-black">close</span>
    </button>
  </div>
  <form [formGroup]="modalForm" class="px-4 pb-3">

    <!-- PARTNER FORM  -->
    <mat-form-field *ngIf="modalForm.controls.partnerName">
      <mat-label>{{ 'COMMON.PARTNER_NAME' | translate }}</mat-label>
      <input matInput type="text" [formControl]="modalForm.controls.partnerName">
      <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
    </mat-form-field>

    <!--  CHECKBOX FORM  -->
    <div class="d-flex flex-column gap-16" *ngIf="modalForm.controls.accepted">
      <span class="label" *ngIf="process.key == 'VISA'">{{ 'DASHBOARD.DONE.YES_OR_NO_QUESTION' | translate }}</span>

      <div class="d-flex justify-content-start mt-2 gap-24">
        <label class="d-flex gap-8 pointer">
          {{ "COMMON.YES" | translate }}
          <input type="radio" class="lf-radio-input order-first pointer" formControlName="accepted" value="true" [ngClass]="{'border-error':  isModalFormSubmit && modalForm.controls.accepted.errors}">
        </label>

        <label class="d-flex gap-8 pointer">
          {{ "COMMON.NO" | translate }}
          <input type="radio" class="lf-radio-input order-first pointer" formControlName="accepted" value="false" [ngClass]="{'border-error':  isModalFormSubmit && modalForm.controls.accepted.errors}">
        </label>
      </div>
    </div>

    <!--  HOUSING FORM  -->
    <div *ngIf="modalForm.controls.address">
      <mat-form-field class="mb-2">
        <mat-label>{{ 'COMMON.USER.ADDRESS' | translate }}</mat-label>
        <input matInput type="text" [formControl]="modalForm.controls.address">
        <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
      </mat-form-field>

      <div class="d-flex gap-16">
        <mat-form-field class="mb-2">
          <mat-label>{{ 'COMMON.USER.POSTALCODE' | translate }}</mat-label>
          <input matInput type="number" [formControl]="modalForm.controls.postalCode">
          <mat-error> {{ "COMMON.IS_REQUIRED" | translate }} </mat-error>
        </mat-form-field>

        <app-city-input [user]="currentUser" [cityControl]="modalForm.controls.city" [floatLabel]="'float '" (onChange)="selectCity($event)"
                        [labelContent]="'COMMON.USER.STUDY_CITY' | translate" [wantedField]="'studyPlace'"></app-city-input>
      </div>


    </div>

    <div class="d-flex align-items-center justify-content-between mt-3">
      <button class="btn btn-primary" type="submit" (click)="sendDatas()">{{ "COMMON.SUBMIT" | translate }} </button>
      <button class="btn border-0 lightGray" type="button"
              (click)="modal.dismiss();updateProcessState('DONE', process)">
        {{ "DASHBOARD.TOOLTIP.PASS" | translate }}
      </button>
    </div>

  </form>

</ng-template>
